module.exports = __webpack_public_path__ + "5924792b6f57d54b9119bf8fa45d25f6.svg";